export default process.env.ENVCFG === 'cit' ?
  [{
    path: 'styleguide',
    getComponent(nextState, callback) {
      import(/* webpackChunkName: "styleguide" */ './containers/Styleguide')
        .then(component => callback(null, component.default));
    },
    childRoutes: [
      {
        path: 'accordion',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideAccordion')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'bar',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideBar')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'breadcrumbs',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideBreadcrumbs')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'buttons',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideButton')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'card',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideCard')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'checkbox',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideCheckbox')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'calendar',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideCalendar')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'colors',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideColors')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'divider',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideDivider')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'expandableSection',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideExpandableSection')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'form',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideForm')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'grid',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideGrid')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'icons',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideIcons')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'links',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideLink')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'modal',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideModal')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'radio',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideRadio')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'spinner',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideSpinner')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'styles',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideStyles')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'typography',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideTypography')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'rating',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideRating')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: 'tooltip',
        getComponent(location, callback) {
          import(/* webpackChunkName: "styleguide" */ './components/StyleguideTooltip')
            .then(component => callback(null, component.default));
        },
      },
    ],
  },
  ]
  : [];
